import axios from 'axios';

const http = axios.create({
  baseURL: process.env.VUE_APP_GAMES_AJS_API,
  timeout: 5000,
});

export default {
  async getJackpot(config) {
    const channelName = 'web';
    const channelId = 3;

    let baseURL = process.env.VUE_APP_GAMES_AJS_API;

    if (config.environment === 'production' && config.platformDataCenter) {
      const suffix = config.platformDataCenter.toUpperCase();
      baseURL = process.env[`VUE_APP_GAMES_AJS_API_${suffix}`] || baseURL;
    }

    const response = await http.get('/open/nonstandalone', {
      baseURL,
      data: {
        isJackpotRequest: true,
      },
      params: {
        account: config.tenantId,
        game: config.productId,
        channel: channelId,
        location: channelName,
        betshop: channelName,
      },
    });

    return response.data;
  },
};
